import dayjs from "dayjs";

/**
 * El rango de un informe en una línea: "1 – 7 sep 2026", colapsando el mes y el
 * año cuando se repiten. `periodEnd` es exclusivo (la ventana es medio abierta),
 * así que el último día mostrado es el anterior.
 */
export function formatPeriod(periodStart: string, periodEnd: string): string {
  const from = dayjs(periodStart);
  const to = dayjs(periodEnd).subtract(1, "day");
  if (!from.isValid() || !to.isValid()) return "—";

  if (from.isSame(to, "month")) {
    return `${from.format("D")} – ${to.format("D MMM YYYY")}`;
  }
  if (from.isSame(to, "year")) {
    return `${from.format("D MMM")} – ${to.format("D MMM YYYY")}`;
  }
  return `${from.format("D MMM YYYY")} – ${to.format("D MMM YYYY")}`;
}

/**
 * Cuánto queda para que cierre el registro de participantes. Es el plazo que
 * decide si todavía se puede entrar, así que se dice en días y no en fecha suelta.
 */
export function registrationDeadline(endsAt: string | null): {
  label: string;
  urgent: boolean;
} | null {
  if (!endsAt) return null;

  const days = Math.ceil(
    (new Date(endsAt).getTime() - Date.now()) / (1000 * 60 * 60 * 24),
  );
  if (days < 0) return { label: "registro cerrado", urgent: true };
  if (days === 0) return { label: "el registro cierra hoy", urgent: true };
  if (days === 1) return { label: "el registro cierra mañana", urgent: true };
  return { label: `${days} días para registrarse`, urgent: days <= 3 };
}
